/**
 * Serialize the values of a multi-value (`isOneOf`) filter into a single
 * comma-separated URL param. `%` and `,` within a value are percent-escaped so
 * a value that itself contains a comma (e.g. an appliance or region named
 * "North, Site") is not split into several bogus values when read back. `%`
 * must be escaped before `,` so the reverse in `parseFilterValues` is lossless.
 */
export function serializeFilterValues(values: string[]): string {
  return values.map((value) => value.replace(/%/g, '%25').replace(/,/g, '%2C')).join(',')
}

/** Inverse of {@link serializeFilterValues}. */
export function parseFilterValues(param: string): string[] {
  return param.split(',').map((value) => value.replace(/%2C/g, ',').replace(/%25/g, '%'))
}
